<template>
  <div>

    <el-row align="middle">

      <!-- Title area -->
      <el-col :align="title ? 'left' : 'right'" :sm="24" :md="24" :lg="title ? (showSearch ? 8 :  20) : 0">
        <component v-if="this.title" :is="titleHeading" :class="titleClass">
          <i v-if="icon" :class="icon">&nbsp;</i><span v-if="!hideOrgBadge"><org-badge :no-full-name="orgBadgeNoFullName" :organisation="orgBadge" />&nbsp;</span>{{title}}
          <span>
            <el-button
              v-if="showRefresh && !showSearch"
              @click.prevent="refreshTable"
              :type="title ? 'text' : 'success'"
              :plain="!title"
              :circle="!title">
              <i :class="'fa fa-sync-alt ' + (isLoading ? 'fa-spin' : '')"></i>
            </el-button>
            <i v-if="!showRefresh && isLoading" class="fa fa-spinner fa-spin"></i>
          </span>
        </component>

      </el-col>

      <!-- Search area -->
      <el-col v-if="showSearch"align="center" :sm="16" :md="12" :lg="title ? 12 : 20">

        <el-row v-if="isMapActive">
          <el-col :span="24" align="center">

            <i>Map search is active for lat:
              <b>{{mapSearch.lat}}</b> &amp; long:
              <b>{{mapSearch.lng}}</b> with a radius:
              <b>{{mapSearch.radius}}</b>km.
            </i>

          </el-col>
        </el-row>

          <el-row v-else>
            <el-col :span="12" align="right">
                <el-input
                ref="vt-filter-text"
                v-model="filterText"
                type="text"
                size="mini"
                @keyup.enter.native="doFilter"
                :placeholder="searchPlaceholder">
              </el-input>
          </el-col>

          <el-col :span="12" align="left">
            <el-button-group :type="classStyle">
                <el-button size="mini" plain type="primary" @click.prevent="doFilter">
                  <i class="fa fa-search"></i>
                </el-button>
                <el-button size="mini" plain type="info" @click.prevent="resetFilter">
                  <i class="fa fa-times-circle"></i>
                </el-button>
                <el-button
                  v-if="showRefresh"
                  plain
                  type="success"
                  size="mini"
                  @click.prevent="refreshTable">
                  <i :class="'fa fa-sync-alt ' + (isLoading ? 'fa-spin' : '')"></i>
                </el-button>
            </el-button-group>
          </el-col>

          </el-row>

      </el-col>

      <el-col v-if="comp" :sm="8" :md="12" :lg="4" align="right" >
        <component v-bind="propsComp" :is="comp"></component>
      </el-col>

    </el-row>

    <hr />

    <div v-if="bottomComp">
      <component v-bind="bottomCompProps" :is="bottomComp"></component>
    </div>

    <el-row v-if="showSort && !isMapActive"
    style="background-color: #F2F6FC; width: 100%; padding: 0.528em; margin-top: -16px;"
    type="flex" justify="center">

      <el-col align="left">
        <i class="text-muted">Sort by:</i>
      </el-col>

      <div v-if="sortFields && sortFields.length <= 4">
        <el-row type="flex" justify="center" :gutter="34">
            <el-col  v-for="(s, index) in sortFields" :key="index" align="center">
              <el-radio v-model="sortField" :label="s" @change="doSort" />
            </el-col>
        </el-row>
    </div>
      <el-col v-else align="center">
        <select-input style="background-color: #F2F6FC;" :list="sortFields" v-model="sortField" @change="doSort" no-form />
      </el-col>

      <el-col align="right">

        <el-tooltip :content="sortField ? sortField + ': ' + sortDir : 'Please select a sort field'" placement="top">
            <el-switch
            v-model="sortDir"
            active-icon-class="fa fa-sort-amount-up text-success"
            inactive-icon-class="fa fa-sort-amount-down text-danger"
            active-value="asc"
            inactive-value="desc"
            :disabled="!sortField"
            @change="changeSort">
          </el-switch>
        </el-tooltip>

      </el-col>

    </el-row>

  </div>
</template>

<script>

import {MAP_SEARCH_EVENT, MAP_RESET_EVENT} from '@/components/Data'

export default {
  name: 'filter-bar',


  props: {

    title: {
      type: String,
      default: null
    },

    titleHeading: {
      type: String,
      default: 'h4'
    },

    titleClass: {
      type: String,
      default: null
    },

    icon: {
      type: String,
      default: null
    },

    comp: {
      type: Object,
      default: null
    },

    compProps: {
      type: Object,
      default: null
    },

    bottomComp: {
      type: Object,
      default: null
    },

    bottomCompProps: {
      type: Object,
      default: null
    },


    searchValue: {
      type: String,
      default: ''
    },

    hideOrgBadge: {
      type: Boolean,
      default: false
    },

    orgBadgeNoFullName: {
      type: Boolean,
      default: false
    },

    orgBadge: {
      type: Object,
      default: null
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Search'
    },

    showSort: {
      type: Boolean,
      default: false
    },

    sortFields: {
      type: Array,
      default: null
    },

    classStyle: {
      type: String,
      default: 'info'
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    defaultFilter: {
      type: String,
      default: null
    },

    setSortEvent: {
      type: String,
      default: 'sort-set'
    },

    setFilterEvent: {
      type: String,
      default: 'filter-set'
    },

    resetFilterEvent: {
      type: String,
      default: 'filter-reset'
    },

    setLoadingEvent: {
      type: String,
      default: 'table-loading'
    },

    setLoadedEvent: {
      type: String,
      default: 'table-loaded'
    },

    refreshEvent: {
      type: String,
      default: 'refresh-table'
    },

    tableLoading: {
      type: String,
      default: 'table-loading'
    },

    tableLoaded: {
      type: String,
      default: 'table-loaded'
    }
  },


  methods: {

    refreshTable () {
      this.isLoading = true
      this.$events.fire(this.refreshEvent)
    },

    changeSort (value) {
      this.sortDir = value
      this.doSort(this.sortField)
    },

    doSort (value) {
      this.sortField = value

      if (this.sortField) {
        this.isLoading = true
        value = {}
        value.sortField = this.sortField
        value.sortDirection = this.sortDir

        this.$events.fire(this.setSortEvent, value)
      }

    },

    doFilter () {
      this.isLoading = true
      let filter = this.filterText
/*
      if (this.defaultFilter) {
        filter = this.defaultFilter + ',' + this.filterText
      } else {
        filter = this.filterText
      }
*/
      this.$events.fire(this.setFilterEvent, filter)
    },

    resetFilter () {
      this.isLoading = true
      this.filterText = ''
      this.$events.fire(this.resetFilterEvent)
    },

    loading () {
      this.isLoading = true
    },

    loaded () {
//      console.log('finished loading table')
      this.isLoading = false
    },

    mapFilter (search) {
      this.isMapActive = true

      if (this.propsComp) {
        this.propsComp.disabled = true
      } else {
        this.propsComp = {disabled: true}
      }

//      console.log('props', this.propsComp)

      this.mapSearch = search
    },

    mapClear () {
      this.isMapActive = false
      this.propsComp = this.orgPropsComp

      if (this.propsComp) {
        this.propsComp.disabled = false
      }

//      console.log('props', this.propsComp)

    }
  },

  watch: {

    action: function (action) {
      this.action = action
    },

    actionProps: function (props) {
      this.actionProps = props
    }

  },

  data () {
    return {
      propsComp: this.compProps,
      orgPropsComp: this.compProps,
      isLoading: true,
      isMapActive: false,
      mapSearch: null,
      filterText: this.searchValue,
      style: 'padding-top: 1.528em;',
      sortField: null,
      sortDir: 'ASC'
    }
  },

  mounted () {
    this.$events.listen(MAP_SEARCH_EVENT, this.mapFilter)
    this.$events.listen(MAP_RESET_EVENT, this.mapClear)

    this.$events.listen(this.tableLoading, this.loading)
    this.$events.listen(this.tableLoaded, this.loaded)
  },

  beforeDestroy () {
    this.$events.remove(MAP_SEARCH_EVENT)
    this.$events.remove(MAP_RESET_EVENT)

    this.$events.remove(this.tableLoading)
    this.$events.remove(this.tableLoaded)
  }
}
</script>
